var React = require('react');

function Bolt (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","strokeWidth":"2","strokeLinejoin":"bevel","strokeMiterlimit":"10","d":"M40 1L17 37h14l-7 26 26-36H36z"}));
}

Bolt.defaultProps = {"width":"64","height":"64"};

module.exports = Bolt;

Bolt.default = Bolt;
